<template>
	<div class="right-nav-scroll show-scrollbar">
    <notifications></notifications>
	</div>
</template>

<script>
  import Notifications from '@/views/nav/Notifications';
  export default {
		name: 'RightNav',

		props: [],

		components: {
      Notifications,

		},

		data: function() {
			return {

			};
		},

		mounted(){

    },

		beforeDestroy() {},

		methods: {

		},

		computed: {

    }
	};
</script>

<style scoped lang="scss">
	.right-nav-scroll {
		min-width: 0;
		min-height: 0;
		flex: 1;
		overflow-x: hidden;
		overflow-y: auto;
		overscroll-behavior: contain;
		scrollbar-gutter: stable;
	}
</style>
